/*********************************************************
 * Copyright (C) 2016-2023 VMware, Inc. All rights reserved.
 *********************************************************/
/**
 * @fileoverview logservice.js -- logService
 * service to handle logs, depend on log which is defined in
 * appblast-log.js
 */

/**
 *  NOTE: this is the workaround for RTAV workers.
 *  We don't use webpack for these workers as there are many complex function
 *  in them. As a result, we have to use this ugly way to expose 'log' to other
 *  webpack module, but not for worker context.
 */
var log;
if (typeof require === 'function') {
   log = require('./worker-log');
}

var RTAV = {};

var logService = (function() {
   var ret = {},
   port,
      coreServer = log,
      functionMap = {
         "trace": "trace",
         "debug": "debug",
         "log": "info",
         "warn": "warn",
         "devError": "error",
         "error": "error"
      };

   /**
    * Helper function used to create a string with a desired length by padding
    * it with preceding zeroes, if necessary.
    *   pad(1, 5) will return "00001".
    *   pad("100", 1) will return "100".
    *   pad(-1, 5) will return "-00001".
    *   pad("-10", 4) will return "-0010".
    *
    * @param  {number} value  The number need to be padded
    * @param  {number} maxLen The padding max length
    * @return {number}        This returns the number which is padded to the
    *     appropriate length.
    */
   function pad(value, maxLen) {
      var string = value.toString(),
         negative = (string.indexOf("-") === 0),
         length = negative ? string.length - 1 : string.length;
      return length < maxLen ?
         pad(negative ? "-0" + string.slice(1) : "0" + string, maxLen) : string;
   }

   /**
    * Get current time as string
    * @return {string} This returns the current time
    */
   function getLogPrefix(LogName) {
      var logTime = new Date();

      return "[" + logTime.getFullYear() + "-" +
         pad(logTime.getMonth() + 1, 2) + "-" + pad(logTime.getDate(), 2) +
         "T" +
         pad(logTime.getHours(), 2) + ":" + pad(logTime.getMinutes(), 2) + ":" +
         pad(logTime.getSeconds(), 2) + "." +
         pad(logTime.getMilliseconds(), 3) +
         "][RTAV]["+LogName+"]: ";
   }

   /**
    * Determind whether a object need to be stringified
    * @param  {any} arg The param we need to print out in the log
    * @return {boolean} This returns whether the arg will looks better in the
    *    stringified format
    */
   function needStringify(arg) {
      var needList = ['Event', 'Object'],
         argType = Object.prototype.toString.call(arg),
         i;

      for (i = 0; i < needList.length; i++) {
         if (argType === '[object ' + needList[i] + ']') {
            return true;
         }
      }
      return false;
   }

   /**
    * Return the log function which will print log with current time with
    * logName
    * @param  {string} logName The name of log function in the logService
    * @return {function} This returns the log function corresponding to logName
    */
   function getLogFunction(logName) {
      return function(arg) {
         var logFunction = coreServer[functionMap[logName]].bind(coreServer),
            logtext;
         // stringfy only for real Object, array or other data has better look
         // in the non-json format
         if (needStringify(arg)) {
            logtext = getLogPrefix(logName) + JSON.stringify(arg);
         } else {
            logtext = getLogPrefix(logName) + arg;
         }
         logFunction(logtext);
         var currentLevel = coreServer.logLevel;
         var lognameInWorkLog = functionMap[logName];
         if((coreServer.levels.indexOf(lognameInWorkLog)>=currentLevel) && isChromeClient()) {
            if (port) {
               port.postMessage({ log: logtext });
            }
         }
      };
   }

   function isChromeClient() {
      let isChromeClient;
      try {
         // Edge has chrome, but doesn't has chrome.management
         isChromeClient =
            !!chrome && !!chrome.management ? true : false;
      } catch (e) {
         // Safari/Firefox/IE is throwing error here
         isChromeClient = false;
      }
      return isChromeClient;
   }

   /**
    * Define log functions with key in functionMap
    */
   function defineFunctions() {
      var key;
      for (key in functionMap) {
         if (functionMap.hasOwnProperty(key)) {
            ret[key] = getLogFunction(key);
         }
      }
   }

   /**
    * Sets the current log level for coreServer.
    * @param {number} level A interger from [0,4]
    */
   ret.setLevel = function(level) {
      if (!coreServer) {
         console.error(
            "the coreServer is not defined in the RTAV.logService when set log level");
      }
      coreServer.setLevel(level);
      this.debug("the rtav log service is ready, while level is as " + level);
   };

   /**
    * Gets the current log level for coreServer.
    * @return {number} This returns a interger from [0,4]
    */
   ret.getLevel = function() {
      if (!coreServer) {
         console.error(
            "the coreServer is not defined in the RTAV.logService when get log level");
         return 2;
      }
      return coreServer.logLevel;
   };

   ret.isChromeClient = isChromeClient;
   if (isChromeClient()) {
      port = chrome.runtime.connect({ name: "WriteFile" });
   }
   defineFunctions();

   return ret;
}());

RTAV.logService = logService;

/**
 *  NOTE: this is the workaround for RTAV workers.
 */
if (typeof module !== "undefined" && module.exports) {
   module.exports = RTAV;
}